// import { CheckoutDataContext } from 'context/merchant-details.context';
import React, {
 useContext, useEffect, useMemo, useState
} from 'react';
import { useLocation } from 'react-router-dom';
import qs from 'query-string';
import { CheckoutDataContext } from 'context/merchant-details.context';
import { getCachedFormData, setCachedFormData } from 'util/formDataCache';
import CustomerInfo from './CustomerInfo';
import PaymentDetails from './PaymentDetails';
import OrderDetails from './OrderDetails';

interface FormData {
  fname: string;
  lname: string;
  email: any;
  phoneNumber: any;
  streetAddress: string;
  streetAddress2: string;
  city: string;
  country: string;
  region: string;
  state: string;
  postalCode: string;
  orderAmount: any;
  tipAmount: any;
}

const GetPaidIndex = () => {
  const defaultCountry = 'AU';
  const [value, setValue] = useState<any>(0);
  const { checkoutData } = useContext(CheckoutDataContext);
  const sessionToken = useMemo(
    () => qs.parse(window.location.search).session_token as string,
    []
  );
  const [formData, setFormData] = useState<FormData>(() => ({
    fname: '',
    lname: '',
    email: '',
    phoneNumber: '',
    streetAddress: '',
    streetAddress2: '',
    city: '',
    country: defaultCountry,
    region: '',
    state: '',
    postalCode: '',
    orderAmount: checkoutData?.merchant.orderAmount,
    tipAmount: 0,
    ...getCachedFormData(sessionToken),
  }));

  const location = useLocation();
  const selectedTab = location.pathname.split('/')[3];

  useEffect(() => {
    setCachedFormData(sessionToken, formData);
  }, [formData, sessionToken]);

  useEffect(() => {
    if (checkoutData?.merchant.paymentType === 'CHPP') {
      setFormData((prev) => ({
        ...prev,
        orderAmount: checkoutData?.merchant.orderAmount,
        email: checkoutData?.merchant.email,
        phoneNumber: checkoutData?.merchant.phoneNumber,
      }));
    } else if (checkoutData?.merchant.paymentType === 'GHPP') {
      setFormData((prev) => ({
        ...prev,
        orderAmount: checkoutData?.merchant.orderAmount,
      }));
    }
  }, [checkoutData]);

  useEffect(() => {
    if (selectedTab) {
      setValue(selectedTab);
    }
  }, [selectedTab]);

  return (
    <>
      {value === 0 && (
        <CustomerInfo
          formData={formData}
          setFormData={setFormData}
          setValue={setValue}
          value={value}
        />
      )}
      {value === 1 && (
        <PaymentDetails
          formData={formData}
          setFormData={setFormData}
          setValue={setValue}
          value={value}
        />
      )}
      {value === 2 && <OrderDetails value={value} />}
    </>
  );
};

export default GetPaidIndex;
